import { CSSProperties } from "react";

export type StylingProps = {
  className?: string;
  style?: CSSProperties;
};

export type PropsWithStyling<T> = T & StylingProps;

export type PropsWithTestId<T> = T & {
  "data-testid"?: string;
};
